export default "__VITE_ASSET__c7c9920c__"